// Dependencies
import axios from 'axios';
import dayjs from 'dayjs';

// Variables
const baseURL = process.env.REACT_APP_API_URL;

// Parse JWT
export const parseToken = (token) => {

	// Process token
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var final = decodeURIComponent(Array.prototype.map.call(atob(base64), function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); }).join(''));

	// Return parsed
	return JSON.parse(final);

}

// Login
export const login = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/auth/login', data).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Forgot password
export const forgotPassword = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/auth/forgot_password', data).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Reset password
export const resetPassword = async (data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/auth/reset_password', data).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get provinces
export const getProvinces = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/province', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get genders
export const getGenders = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/user_gender', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get user types
export const getUserTypes = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/user_type', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get admin tenants
export const getAdminTenants = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/tenant', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save admin tenant
export const saveAdminTenant = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('referalCode', data.referalCode);
	formData.append('primaryColor', data.primaryColor);
	formData.append('secondaryColor', data.secondaryColor);
	formData.append('tertiaryColor', data.tertiaryColor);
	formData.append('active', data.active);
	formData.append('logoFile', data.logo);
	formData.append('isotypeFile', data.isotype);

	// Request
	axios.post(baseURL + '/admin/tenant', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update admin tenant
export const updateAdminTenant = async (id, data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('referalCode', data.referalCode);
	formData.append('primaryColor', data.primaryColor);
	formData.append('secondaryColor', data.secondaryColor);
	formData.append('tertiaryColor', data.tertiaryColor);
	formData.append('active', data.active);
	formData.append('logoFile', data.logo);
	formData.append('isotypeFile', data.isotype);

	// Request
	axios.patch(baseURL + '/admin/tenant/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete admin tenant
export const deleteAdminTenant = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/tenant/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get partners
export const getPartners = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/partner', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save partner
export const savePartner = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('website', data.website);
	formData.append('active', data.active);
	formData.append('file', data.logo);

	// Request
	axios.post(baseURL + '/admin/partner', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update partner
export const updatePartner = async (id, data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('website', data.website);
	formData.append('active', data.active);
	formData.append('file', data.logo);

	// Request
	axios.patch(baseURL + '/admin/partner/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete partner
export const deletePartner = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/partner/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get levels
export const getLevels = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/level', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save level
export const saveLevel = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/level', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}


// Update level
export const updateLevel = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/level/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete level
export const deleteLevel = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/level/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get branches
export const getBranches = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/branch', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save branch
export const saveBranch = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/branch', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update branch
export const updateBranch = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/branch/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete branch
export const deleteBranch = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/branch/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get categories
export const getCategories = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/category', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save category
export const saveCategory = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('file', data.image);

	// Request
	axios.post(baseURL + '/admin/category', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update category
export const updateCategory = async (id, data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('name', data.name);
	formData.append('file', data.image);

	// Request
	axios.patch(baseURL + '/admin/category/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete category
export const deleteCategory = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/category/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get branches from partner
export const getBranchesFromPartner = async (pid, scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/branch?partner=' + pid, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get discount types
export const getDiscountTypes = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/discount_type', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get benefit types
export const getBenefitTypes = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/benefit_type', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save benefit type
export const saveBenefitType = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/benefit_type', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update benefit type
export const updateBenefitType = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/benefit_type/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete benefit type
export const deleteBenefitType = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/benefit_type/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get benefits
export const getBenefits = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/benefit${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save benefit
export const saveBenefit = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/benefit', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update benefit
export const updateBenefit = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/benefit/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete benefit
export const deleteBenefit = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/benefit/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get coupons
export const getCoupons = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/coupon', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save coupon
export const saveCoupon = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/coupon', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save benefit level
export const saveBenefitLevel = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('points', data.points);
	formData.append('discount', data.discount);
	formData.append('days', data.days);
	formData.append('maxPerUser', data.maxPerUser);
	formData.append('benefit', JSON.stringify({ id: data.benefit.id }));
	formData.append('level', JSON.stringify({ id: data.level.id }));
	formData.append('file', data.image);
	formData.append('previewFile', data.previewImage);

	// Request
	axios.post(baseURL + '/admin/benefit_level', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete benefit level
export const deleteBenefitLevel = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/benefit_level/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update benefit level
export const updateBenefitLevel = async (id, data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('points', data.points);
	formData.append('discount', data.discount);
	formData.append('days', data.days);
	formData.append('maxPerUser', data.maxPerUser);
	formData.append('benefit', JSON.stringify({ id: data.benefit.id }));
	formData.append('level', JSON.stringify({ id: data.level.id }));
	formData.append('file', data.image);
	formData.append('previewFile', data.previewImage);

	// Request
	axios.patch(baseURL + '/admin/benefit_level/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get benefit levels
export const getBenefitLevels = async (id, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/benefit_level?benefitId=${id}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get post categories
export const getPostCategories = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/post_category', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get posts
export const getPosts = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/post', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save post
export const savePost = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('title', data.title);
	// formData.append('body', `'${JSON.stringify(data.body)}'`);
	formData.append('body', data.body);
	formData.append('startDate', data.startDate);
	formData.append('endDate', data.endDate);
	formData.append('postCategory', JSON.stringify({ id: data.postCategory.id }));
	formData.append('file', data.image);

	// Request
	axios.post(baseURL + '/admin/post', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update post
export const updatePost = async (id, data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('title', data.title);
	// formData.append('body', `'${JSON.stringify(data.body)}'`);
	formData.append('body', data.body);
	formData.append('startDate', data.startDate);
	formData.append('endDate', data.endDate);
	formData.append('postCategory', JSON.stringify({ id: data.postCategory.id }));
	formData.append('file', data.image);

	// Request
	axios.patch(baseURL + '/admin/post/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete post
export const deletePost = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/post/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get all beta users
export const getAllBetaUsers = async (scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/contact_user/all`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get all beta users
export const getAllBetaPartners = async (scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/contact_partner/all`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get beta users
export const getBetaUsers = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/contact_user${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get partner users
export const getPartnerUsers = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/contact_partner${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});
}

// Get banners
export const getBanners = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/banner${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save banner
export const saveBanner = async (data, scb, ecb) => {
	// Create form data
	const formData = new FormData();
	formData.append('title', data.title);
	formData.append('description', data.description);
	formData.append('startDate', data.startDate);
	formData.append('endDate', data.endDate);
	formData.append('cooldown', data.cooldown);
	formData.append('file', data.file);
// Request
	axios.post(baseURL + '/admin/banner', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-Type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete banner
export const deleteBanner = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/banner/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update banner
export const updateBanner = async (id, data, scb, ecb) => {

	// Create form data
	const formData = new FormData();
	formData.append('title', data.title);
	formData.append('description', data.description);
	formData.append('startDate', dayjs(data.startDate).toISOString());
	formData.append('endDate', dayjs(data.endDate).toISOString());
	formData.append('cooldown', data.cooldown);
	formData.append('file', data.file);

	// Request
	axios.patch(baseURL + '/admin/banner/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);
		}
	});
};

// Get participating cities
export const getParticipatingCities = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/participating-city${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save participating city
export const saveParticipatingCity = async (data, scb, ecb) => {

	// Create form data
	const formData = new FormData();
	formData.append('name', data.name);
	formData.append('province', JSON.stringify(data.province));
	formData.append('file', data.file);

	// Request
	axios.post(baseURL + '/admin/participating-city', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-Type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete participating city
export const deleteParticipatingCity = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/participating-city/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update participating city
export const updateParticipatingCity = async (id, data, scb, ecb) => {

	// Create form data
	const formData = new FormData();
	formData.append('name', data.name);
	formData.append('file', data.file);

	// Request
	axios.patch(baseURL + '/admin/participating-city/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);
		}
	});
};

// Get supports
export const getSupports = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/support${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save support
export const saveSupport = async (data, scb, ecb) => {

	// Create form data
	const formData = new FormData();
	formData.append('name', data.name);
	formData.append('file', data.file);

	// Request
	axios.post(baseURL + '/admin/support', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-Type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update support
export const updateSupport = async (id, data, scb, ecb) => {

	// Create form data
	const formData = new FormData();
	formData.append('name', data.name);
	formData.append('file', data.file);

	// Request
	axios.patch(baseURL + '/admin/support/' + id, formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);
		}
	});
};

// Delete support
export const deleteSupport = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/support/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get users
export const getUsers = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/user${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update Wepoints
export const updateUserPoints = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/user/' + id + '/points', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);
		}
	});
};

// Save benefit code
export const saveBenefitCode = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/benefit_code', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get benefit codes
export const getBenefitCodes = async (id, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/benefit_code?benefitId=${id}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get notifications
export const getNotifications = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/notification', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save notification
export const saveNotification = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/notification', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update notification
export const updateNotification = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/notification/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete notification
export const deleteNotification = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/notification/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get challenges
export const getChallenges = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/challenge', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save challenge
export const saveChallenge = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/challenge', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update challenge
export const updateChallenge = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/challenge/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete challenge
export const deleteChallenge = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/challenge/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get challenge types
export const getChallengeTypes = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/challenge_type', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get tenants
export const getTenants = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/tenant', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get locations
export const getLocations = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/location', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get location types
export const getLocationTypes = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/location_type', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save location
export const saveLocation = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/location', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update location
export const updateLocation = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/location/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete location
export const deleteLocation = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/location/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get tenant users
export const getTenantUsers = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/user', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save tenant user
export const saveTenantUser = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/user', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update tenant user
export const updateTenantUser = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/user/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete tenant user
export const deleteTenantUser = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/user/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get cities
export const getCities = async (scb, ecb) => {

	// Request
	axios.get(baseURL + '/admin/city', {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete city
export const deleteCity = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/city/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Upload tenant users
export const uploadTenantUsers = async (data, scb, ecb) => {

	// Create form data
	var formData = new FormData();
	formData.append('file', data.file);

	// Request
	axios.post(baseURL + '/admin/user/csv', formData, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			'Content-type': 'multipart/form-data',
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Get admin users
export const getAdminUsers = async (query, scb, ecb) => {

	// Request
	axios.get(baseURL + `/admin/tenant-admin?${query}`, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data === '' ? { data: [] } : response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Save admin user
export const saveAdminUser = async (data, scb, ecb) => {

	// Request
	axios.post(baseURL + '/admin/auth/register', data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Update admin user
export const updateAdminUser = async (id, data, scb, ecb) => {

	// Request
	axios.patch(baseURL + '/admin/tenant-admin/' + id, data, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}

// Delete admin user
export const deleteAdminUser = async (id, scb, ecb) => {

	// Request
	axios.delete(baseURL + '/admin/tenant-admin/' + id, {
		headers: {
			'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
		}
	}).then((response) => {

		// Success callback
		scb(response.data);

	}).catch((error) => {

		// Conditions
		if (error.response) {

			// Error callback
			ecb(error.response.data);

		} else {

			// Log error
			console.log(error);

		}

	});

}
